import React, { useEffect, useState } from 'react';

const YoutubePlayer = ({ youtubeUrl }) => {

    const [embedUrl, setEmbedUrl] = useState('');
    // Function to convert YouTube URL to Embed URL
    const convertToEmbedUrl = (url) => {
        // If the URL is from youtu.be (e.g., https://youtu.be/JrNMyzsYr4M)

        if (url.includes('youtu.be')) {
            const videoId = url.split('/').pop().split('?')[0]; // Extract video ID
            return `https://www.youtube.com/embed/${videoId}`;
        }
        // If the URL is a standard YouTube URL (e.g., https://www.youtube.com/watch?v=JrNMyzsYr4M)
        else if (url.includes('youtube.com/watch')) {
            const videoId = new URL(url).searchParams.get('v'); // Get video ID from query params

            console.log('Video ID: ', videoId)

            return `https://www.youtube.com/embed/${videoId}`;
        }
        return ''; // Return empty if URL is not valid
    };

    useEffect(() => {
        // Convert the database URL to an embed URL
        if (youtubeUrl) {
            setEmbedUrl(convertToEmbedUrl(youtubeUrl));
        }
    }, [youtubeUrl]);

    return (
        // <div className="w-full aspect-w-16 aspect-h-8 lg:h-80 rounded-lg">
        <div className="w-full lg:h-[400px]">
            {embedUrl ? (
                <iframe
                    width="100%"
                    height="100%"
                    src={embedUrl}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className='aspect-video w-full'
                ></iframe>
            ) : (
                <p className='text-white font-sm'>Loading video...</p>
            )}
        </div>
    );
};

export default YoutubePlayer;
